import momentTimezone from 'moment-timezone'

export default {
  computed: {
    timezones () {
      return momentTimezone.tz.names()
    }
  }
}
